import { render, staticRenderFns } from "./DSi.vue?vue&type=template&id=34609c50&"
import script from "./DSi.vue?vue&type=script&lang=js&"
export * from "./DSi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports